// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ae73662e","453":"bfaeb4f7","772":"40cc3152","826":"4894273f"}[chunkId] + ".chunk.js";
};